import React from "react";
import SelectOrderStrategy from "./SelectOrderStrategy";
import {OrderExecutorCreateInvoiceStrategies} from "../../../../app/order/GetStrategies";

const OrderExecutorCreateInvoiceStrategyType = React.forwardRef(({onChange, ...props}, ref) => (
    <SelectOrderStrategy onChange={onChange} strategies={OrderExecutorCreateInvoiceStrategies} {...props} ref={ref}/>
));

export default OrderExecutorCreateInvoiceStrategyType;